import MarketingLayout from '$components/MarketingLayout';
import Hero from '$components/Hero';
import MarketingSection from '$components/MarketingSection';
import MarketingDivide from '$components/MarketingDivide';
import MarketingCodebox from '$components/MarketingCodebox';
import MarketingBullets from '$components/MarketingBullets';
import Testimonial from '$components/MarketingTestimonial';
import React from 'react';
export default {
  MarketingLayout,
  Hero,
  MarketingSection,
  MarketingDivide,
  MarketingCodebox,
  MarketingBullets,
  Testimonial,
  React
};